var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76518 0.765165C7.91162 0.618718 7.91162 0.381282 7.76518 0.234835C7.61873 0.0883883 7.38129 0.0883883 7.23485 0.234835L4.00001 3.46968L0.765165 0.234836C0.618718 0.0883898 0.381282 0.0883898 0.234835 0.234836C0.0883883 0.381283 0.0883883 0.61872 0.234835 0.765167L3.46968 4.00001L0.234848 7.23484C0.0884018 7.38128 0.0884018 7.61872 0.234848 7.76516C0.381295 7.91161 0.618732 7.91161 0.765179 7.76516L4.00001 4.53034L7.23484 7.76517C7.38128 7.91161 7.61872 7.91161 7.76516 7.76517C7.91161 7.61872 7.91161 7.38128 7.76516 7.23484L4.53034 4.00001L7.76518 0.765165Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.277bebff7bbf4bc5a4b3e14f8d84321f.svg";
export { ForwardRef as ReactComponent };